export default "__VITE_ASSET__67ac9949__"